import script from "./ExportComplete.vue?vue&type=script&setup=true&lang=ts"
export * from "./ExportComplete.vue?vue&type=script&setup=true&lang=ts"

import "./ExportComplete.vue?vue&type=style&index=0&id=dab275be&lang=scss"

const __exports__ = script;

export default __exports__